import React from 'react'
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom"
import { selectProject } from '../../../redux/selectedProjectSlice';

export default function FormCard(props) {
    const dispatch = useDispatch()
    var formUrl = "/form/" + props?.formName + "/documents";

    return (
        <Link to={formUrl} onClick={() => dispatch(selectProject({ id: '', name: props?.project_name }))}>
            <div className="project-card folder">
                <h2>{props?.formName}</h2>
                <p className='card-description'>{props?.description}</p>
                <p className="last-update">{props?.lastUpdated}</p>
            </div>
        </Link>
    )
}
